import React from 'react'

import Login from '../../../react4xp/components/Login'
import CreateUser from '../../../react4xp/components/CreateUser'
import EditProfile from '../../../react4xp/components/EditProfile'

function UserPagePart({ user, mode, logoutUrl, registerUrl, registerServiceUrl, editServiceUrl, deleteServiceUrl, profilePageUrl, termsAndConditionsUrl,  strings }) {
    if (mode == 'login') {
        return (
            <Login
                profilePageUrl={profilePageUrl}
                registerUrl={registerUrl}
                strings={strings}
            />
        )
    } else if (mode == 'registration') {
        return (
            <CreateUser 
                logoutUrl={logoutUrl}
                profilePageUrl={profilePageUrl}
                registerServiceUrl={registerServiceUrl}
                termsAndConditionsUrl={termsAndConditionsUrl}
                strings={strings}
            />
        )
    } else if (mode == 'profile') {
        return (
            <EditProfile
                strings={strings}
                user={user}
                deleteServiceUrl={deleteServiceUrl}
                editServiceUrl={editServiceUrl}
                logoutUrl={logoutUrl}
            />
        )
    }
}

export default (props) => <UserPagePart {...props} />
